import {RouterModule, Routes} from '@angular/router';
import {HeaderComponent} from '@labshare/base-ui/header';
import {ConfigResolverService} from '@labshare/base-ui/theme';
import {generatedRoutes} from './ui-modules/module-routes';
import {NgModule} from '@angular/core';
import {HeaderLogoComponent} from './header-logo/header-logo.component';
import {AsrRoutePath} from '../../..//ngx-asr-lib/src/lib/constants';
import {AsrUserProfileComponent} from '../app/asr-user-profile/asr-user-profile.component';
import {FooterComponent} from './footer/footer.component';
import {LayoutComponent} from './layout/layout.component';
import {AsrApiTestComponent} from './asrapitest/asrapitest.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: [AsrRoutePath.ASR_URL, AsrRoutePath.HOME_URL].join('/'),
    pathMatch: 'full'
  },
  {
    path: '',
    data: {
      theme: 'labshare'
    },
    component: LayoutComponent,
    resolve: {items: ConfigResolverService},
    children: [
      {
        path: 'asrapitest',
        component: AsrApiTestComponent
      },
      {
        path: AsrRoutePath.ASR_URL,
        loadChildren: () => import('projects/ngx-asr-lib/src/lib/ngx-asr.module').then(module => module.NgxAsrModule)
      },
      {
        path: '',
        component: HeaderComponent,
        outlet: 'header',
        data: {
          config: {
            logoComponent: HeaderLogoComponent,
            centerNavList: [],
            rightNavList: [
              {
                type: 'component',
                component: AsrUserProfileComponent
              }
            ]
          }
        }
      },
      {
        path: '',
        component: FooterComponent,
        outlet: 'footer'
      },

      /* Routes automatically generated by LSC/Shell-UI */
      ...generatedRoutes
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      relativeLinkResolution: 'corrected'
    })
  ],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {}
